@if (isLoadingResults) {
  <div class="example-loading-shade h-[calc(100vh-210px)]">
    @if (isLoadingResults) {
      <mat-spinner [style.zoom]="1"></mat-spinner>
    }
  </div>
}
<!-- If payment mode is EZIDBIT -->
@if (paymentMode == 'EZIDEBIT') {
  <div id="contacts" class="con page-layout simple left-sidebar inner-sidebar inner-scroll w-full">
    <!-- HEADER -->
    <!-- <div class="header business_head_tab accent p-4 p-sm-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="logo" fxLayout="row" fxLayoutAlign="start center">
        <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
          {{clickbtn}}
        </span>
      </div>
    </div>
    <div class="ml-sm-32" fxLayout="row" fxLayoutAlign="center center" fxFlex> </div>
  </div> -->
    <div class="content">
      <!-- <fuse-sidebar class="sidebar" name="contacts-main-sidebar-1" position="left" lockedOpen="gt-sm">
    <div class="content">
      <div class="sidebar-content">
        <div class="card">
          <div class="content py-16">
            <div class="nav material2">
              <div class="nav-item name" aria-label="inbox">
                <a (click)="loading_fun()" (click)="basicInfoClick()" class="nav-link" matRipple [ngClass]="{'active accent':clickbtn ==='Basic Information'}">
                  <span class="title">Basic Information</span>
                </a>
              </div>
              <div class="nav-item name" aria-label="inbox">
                <a (click)="loading_fun()" (click)="ProductClick()" class="nav-link" matRipple [ngClass]="{'active accent':clickbtn ==='Products'}">
                  <span class="title">Products</span>
                </a>
              </div>
              <div class="nav-item name" aria-label="inbox">
                <a (click)="loading_fun()" (click)="ReceiptsClick()" class="nav-link" matRipple [ngClass]="{'active accent':clickbtn ==='Receipts'}">
                  <span class="title">Receipts</span>
                </a>
              </div>
              <div class="nav-item name" aria-label="inbox">
                <a (click)="loading_fun()" (click)="PaymentClick()" class="nav-link" matRipple [ngClass]="{'active accent':clickbtn ==='Payment'}">
                  <span class="title">Payment</span>
                </a>
              </div>
              //Below is commented
              <div class="nav-item name" aria-label="inbox">
                <a (click)="UserActivityClick(); loading_fun()" class="nav-link" matRipple [ngClass]="{'active accent':clickbtn ==='UserActivity'}">
                  <span class="title">User Activity</span>
                </a>
              </div>
              <div class="nav-item defaults" aria-label="inbox">
                <a (click)="loggedOnUser(); loading_fun()" class="nav-link" matRipple [ngClass]="{'active accent':clickbtn ==='LoggedOnUser'}">
                  <span class="title">Currently Logged on Users</span>
                </a>
              </div>
              <div class="nav-item name" aria-label="inbox">
                <a (click)="ExportToSLQ(); loading_fun()" class="nav-link" matRipple [ngClass]="{'active accent':clickbtn ==='ExportToSLQ'}">
                  <span class="title">Export to SLQ </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fuse-sidebar> -->
      <div class="center dropdown2 p-24">
        <div class="content">
          <form name="accountMngForm">
            <mat-accordion class="faqs-accordion">
              <mat-expansion-panel
                label="Contact Details"
                mat-align-tabs="start"
                fxLayout="column"
                (opened)="basicInfoClick()"
              >
                <mat-expansion-panel-header class="Bold_panel_header">
                  Contact Details
                </mat-expansion-panel-header>
                <app-basic-info></app-basic-info>
              </mat-expansion-panel>
              <mat-expansion-panel
                label="Products"
                mat-align-tabs="start"
                fxLayout="column"
                (opened)="ProductClick()"
              >
                <mat-expansion-panel-header class="Bold_panel_header">
                  Products
                </mat-expansion-panel-header>
                <app-products></app-products>
              </mat-expansion-panel>
              <mat-expansion-panel
                label="Receipts"
                mat-align-tabs="start"
                fxLayout="column"
                (opened)="ReceiptsClick()"
              >
                <mat-expansion-panel-header class="Bold_panel_header">
                  Receipts
                </mat-expansion-panel-header>
                <app-receipts></app-receipts>
              </mat-expansion-panel>
              <mat-expansion-panel
                label="Payment"
                mat-align-tabs="start"
                fxLayout="column"
                (opened)="PaymentClick()"
              >
                <mat-expansion-panel-header class="Bold_panel_header">
                  Payment
                </mat-expansion-panel-header>
                <app-payment></app-payment>
              </mat-expansion-panel>
            </mat-accordion>
            <!-- <mat-tab-group animationDuration="0ms" [(selectedIndex)]="tabindex" (selectedTabChange)="onSelectAccount($event);">
        <mat-tab label="Contact Details">
          <app-basic-info *ngIf="clickbtn ==='Contact Details'"></app-basic-info>
        </mat-tab>
        <mat-tab label="Products">
          <app-products *ngIf="clickbtn ==='Products'"></app-products>
        </mat-tab>
        <mat-tab label="Receipts">
          <app-receipts *ngIf="clickbtn ==='Receipts'"></app-receipts>
        </mat-tab>
        <mat-tab label="Payment">
          <app-payment *ngIf="clickbtn ==='Payment'"></app-payment>
        </mat-tab> -->
            <!-- <mat-tab label="UserActivity">
        <app-user-activity *ngIf="clickbtn ==='UserActivity'"></app-user-activity>
      </mat-tab>
      <mat-tab label="LoggedOnUser">
        <app-loggedon-user *ngIf="clickbtn ==='LoggedOnUser'"></app-loggedon-user>
      </mat-tab>
      <mat-tab label="ExportToSLQ">
        <app-export-to-slq *ngIf="clickbtn ==='ExportToSLQ'"></app-export-to-slq>
      </mat-tab> -->
            <!-- </mat-tab-group> -->
            <!-- <app-basic-info *ngIf="clickbtn ==='Basic Information'"></app-basic-info>
    <app-products *ngIf="clickbtn ==='Products'"></app-products>
    <app-receipts *ngIf="clickbtn ==='Receipts'"></app-receipts>
    <app-payment *ngIf="clickbtn ==='Payment'"></app-payment>
    <app-user-activity *ngIf="clickbtn ==='UserActivity'"></app-user-activity>
    <app-loggedon-user *ngIf="clickbtn ==='LoggedOnUser'"></app-loggedon-user>
    <app-export-to-slq *ngIf="clickbtn ==='ExportToSLQ'"></app-export-to-slq> -->
          </form>
        </div>
        <mat-dialog-actions class="popup_ftr justify-end!"></mat-dialog-actions>
      </div>
    </div>
  </div>
}

@if (paymentMode == 'SIGNUP') {
  <ng-container class="con page-layout simple left-sidebar inner-sidebar inner-scroll w-full">
    <h2 class="signupPlanHeading">Choose your plan</h2>
    <p class="signupPlanDesc">
      Select the plan that works best for your practice.
      <br />
      Everything you need to run your modern law firm, including Australian Support
    </p>
  </ng-container>
}
<div id="stripePurchasePlan"></div>

@if (paymentMode == 'STRIPE') {
  <div class="stripe-main-container">
    <div class="stripe-item leading-[1.3]">
      <p>SILQ will now open your billing portal in another tab.</p>
      <p>You will be able to see your past invoices and receipts.</p>
      <p>You can update your subscription, how many licences you need and your payment method.</p>
      <p>
        The portal should open automatically, but if it does not then click on this button to open
        it.
      </p>
      <button
        matButton="filled"
        class="mat-accent"
        style="display: block; margin: auto"
        (click)="openStripeUrl()"
      >
        Click here to open your SILQ Billing Portal
      </button>
    </div>
  </div>
}
